<template>
  <div class="my-movie-page">
    <!-- 导航栏 -->
    <div class="custom-nav-bar">
      <div class="nav-bar-content">
        <div class="nav-bar-left" @click="back">
          <i class="nav-bar-arrow van-icon van-icon-arrow-left"></i>
        </div>
        <div class="nav-bar-title">
          {{$t('myMovie')}}
        </div>
      </div>
    </div>
    
    <!-- 主要内容 -->
    <div class="main-content" ref="mainContent">
      <!-- 用户信息卡片 -->
      <div class="user-card">
        <div class="user-info">
          <div class="avatar-section">
            <div class="avatar-container">
              <img :src="avatarUrl" class="avatar-img" alt="User Avatar">
            </div>
            <div class="user-details">
              <h1 class="username">Hi, {{userInfo.username}}</h1>
              <p class="user-tips">{{$t('completeTaskForMore')}}</p>
            </div>
          </div>
          <div class="ticket-count">
            {{$t('movieTicket')}}{{userInfo.video_money}}
          </div>
        </div>
      </div>

      <!-- 观看记录区域 -->
      <div class="watch-section">
        <div class="section-header">
          <div class="section-title">
            <img :src="watchIcon" class="section-icon" alt="">
            {{$t('watchList')}}
          </div>
        </div>
        
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <!-- 观看记录列表 -->
          <div v-if="watchHistory.length > 0" class="watch-history-list">
            <div 
              v-for="(item, index) in watchHistory" 
              :key="`${item.id}_${index}`" 
              class="history-item"
              @click="playVideo(item)"
            >
              <div class="video-thumbnail">
                <img :src="item.video_pic" :alt="item.video_name" class="thumbnail-img">
                <div class="play-overlay">
                  <i class="play-icon van-icon van-icon-play"></i>
                </div>
              </div>
              <div class="video-info">
                <h3 class="video-title">{{ item.video_name }}</h3>
                <p class="video-meta">
                  <span class="category">{{ item.video_class_name }}</span>
                  <span class="duration">{{ item.video_duration }}</span>
                </p>
                <p class="watch-time">观看时间: {{ formatTime(item.watch_time) }}</p>
              </div>
              <div class="video-actions">
                <van-icon name="delete" @click.stop="deleteHistory(item.id)" />
              </div>
            </div>
          </div>
          
          <!-- 空状态 -->
          <div v-else class="empty-state">
            <div class="van-empty">
              <div class="van-empty__image">
                <img src="/img/z35.png" alt="No data">
              </div>
              <p class="van-empty__description">
                {{$t('noDataYet')}}
              </p>
            </div>
          </div>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: false,
      show: false,
      isBank: false,
      userInfo: {},
      watchHistory: [],
      loading: false,
      finished: false,
      page: 1,
      limit: 20,
      refreshing: false,
      avatarUrl: '/img/logo2a.png',
      watchIcon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAiCAYAAAA3WXuFAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFRUlEQVRYhZ2YW6hdVxWGv29nW2pytBg9PhSt4osoQitFsGAstqgVC2qjiVBBTUtBgqBUCEVQfFBBqRp88vbgQ0GxtehDEyJNTrw0pUJJqQWxVXxRS3LUVmnEmLN+H9bca8912SdHYR/OmnuOOS7/+MeYY21//tFjmCAgKc9BuEZyO8nNwh7JL00eFn4muQDBlDOtPCzPYgILneU/lR0mZCDMG2ZoURRQkbxHcr9xN8u9t6qflJw3PCCeijkpbBpbGSWLoFo9BIrjVPtlr8iUTytz8mMnuohKtG8UnirrZyE/NGxK3ix5t2FPhcolkgckPxZOmZzvou/Q7iPS36e3Bpg3znoRSb5e1r+R7CN5rkVQTPZq9os3S24yWUcOigdNtpQfiA9LTiT8qdPZIcJCT+uCi/RWCJ34+MmaB2sm/2y9zTsMG93emGcvEm6BHDC5Sbh6IHesoHta8sc+z5b8I30OefzQBpXR/ZL7gb+ZvHz5fUXeHpFrhXmT4QOS/ZJrl8QOkjMt7/Kg8AdG6az0PnTH6VrxMcktJg8Kt0nmDiqnrqpisBGaak/DPsntkn3AGwY6zkjuAzYkTy0co+zPtzoO5WrxxvL8TsnzxqoCezzr1l20LT8akxc058WLkqvMsprKmRskN0hIfFLzI8lR4z9C8Cd3/grJPslxk90T/Wi8XqZikM4+P5ZVNMVBah1/lXxQsjFvnO2VnDC5UrMp+bT4uw7+RZW44EyFVItmVzlLNBd9aUFk+3vt85b4iiT3aN4unjJ53bzRI8KV4p9bMmazTg/bGZ1KZy2/8jyV0xwPbpjcqHxt3jh7bxG8T9zkfzJKXwY6RxYpo8+fVU4fUR+V3DrfYrZeFD638tAqJ7u/8ZnVgUG/OATzTNmbzxu9VIxeUSnYo7lK0oyqq0ZiwihjNNRsied68tV54IrF+XnjLEVBisFPSL4irknSQ6HnQAbpWImmki2T4+qtw7ZRUjZbnG/vsr7RazRrRaHbO7BDcie7NNePkRmfr8cPi8J7JA+ZrGFymeraNYlMTey2LTaSx5aOtvf7VHHMGx0pJP5iB1EPyD3u4sOKZAdo9saPQsi3aQ6Lu02aFVHPhAviVyWPTzk6lY6d9LM6ZaEtybskH67up20iytPGx1dU1woHVsiUYEvKgCWBP2N8QvPiulcM+wjkXybf//+6+AjxmkOzUkGd4nOae6ea3VJuh9U11bumy77iEC4H8tGIQc/QZfvOiqh33sVT9aG2hS8dwdEhJpycmpG2d2B7nrUc6ryE9O4qVyvuoTHmED0HVl81QyerKqs5Ml1Z1IoZRsrAaVYanexdZT2P7Y3VGmiVZjHddQa7yppIU9/oJM+GTlymD6lp+3Mn3A6XLRJ9LmWcznXh88Z1zCO28zGa2yQHJf8xfkHztOSlJp9TX237av5vuZ62ag7tKvBezCAN3XBewU9/2kN8v8nhds8DJkdLyr4j7i2GnhcPm7xLc3e5ng5ovin5t8nFjkPBF9Ki8MqW1PTSlV7FWRzt8eyn6rrkVSS/rNL5IZP3qRck3y2pPgk5YvIazRnxYnH4uoL6ll+6+y/fEw6R/F14i+T33RtB/Xaw3S8dI9nq+8HZ3pvrUsdZybUmj8zD7Fshh9SXQc4Gvmg4K1yKdm8dWH7J6Lgj6RM70n6q1pAyMTK47RvjTPNayZ2tM6L57LzRx4RPJXxDWBO/nDo97Zze8ajPs0L+QZlnzLPh9dSvwHaq+Ii4MS++H0V+C9yV8HrhJaVHdr2lNjzm2cL4Sp4NrycljeSc4bT6bckzJvwXm3g8AV5f3OgAAAAASUVORK5CYII='
    };
  },
  mounted() {
    // this.getUserInfo();
    this.getWatchHistory();
  },
  methods: {
    back() {
      return window.history.back();
    },
    
    // 获取用户信息
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      }).catch(error => {
        console.error('获取用户信息失败:', error);
        this.$toast('网络错误');
      });
    },
    
    // 获取观看历史
    getWatchHistory() {
      this.loading = true;
      this.$http({
        method: 'get',
        data: {
          page: this.page,
          limit: this.limit
        },
        url: 'video_watch_history'
      }).then(res => {
        this.loading = false;
        this.refreshing = false;
        
        if (res.code === 200) {
          if (this.page === 1) {
            this.watchHistory = res.data.data || [];
          } else {
            this.watchHistory = [...this.watchHistory, ...(res.data.data || [])];
          }
          
          if (!res.data.data || res.data.data.length < this.limit) {
            this.finished = true;
          }
        } else {
          this.$toast(res.msg || '获取失败');
        }
      }).catch(error => {
        console.error('获取观看历史失败:', error);
        this.loading = false;
        this.refreshing = false;
        this.$toast('网络错误');
      });
    },
    
    // 播放视频
    playVideo(item) {
      const videoId = item.db_video_id || item.video_id;
      console.log('播放视频:', { 
        db_video_id: item.db_video_id, 
        api_video_id: item.video_id, 
        using_id: videoId 
      });
      
      this.$router.push({
        path: '/PlayVideo',
        query: {
          id: videoId,
          url: item.video_url,
          title: item.video_name,
          pic: item.video_pic
        }
      });
    },
    
    // 删除观看记录
    deleteHistory(historyId) {
      this.$dialog.confirm({
        title: '确认删除',
        message: '确定要删除这条观看记录吗？'
      }).then(() => {
        this.$http({
          method: 'post',
          data: {
            id: historyId
          },
          url: 'video_delete_watch'
        }).then(res => {
          if (res.code === 200) {
            this.$toast('删除成功');
            this.page = 1;
            this.finished = false;
            this.getWatchHistory();
          } else {
            this.$toast(res.msg || '删除失败');
          }
        }).catch(error => {
          console.error('删除观看记录失败:', error);
          this.$toast('删除失败');
        });
      }).catch(() => {
        // 用户取消删除
      });
    },
    
    // 格式化时间
    formatTime(timestamp) {
      if (!timestamp) return '未知时间';
      
      const date = new Date(timestamp * 1000);
      const now = new Date();
      const diff = now - date;
      
      if (diff < 60000) {
        return '刚刚';
      } else if (diff < 3600000) {
        return Math.floor(diff / 60000) + '分钟前';
      } else if (diff < 86400000) {
        return Math.floor(diff / 3600000) + '小时前';
      } else if (diff < 604800000) {
        return Math.floor(diff / 86400000) + '天前';
      } else {
        return date.toLocaleDateString();
      }
    },
    
    // 下拉刷新
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.getWatchHistory();
      setTimeout(() => {
        if (this.refreshing) {
          this.refreshing = false;
          this.$toast('刷新成功');
        }
      }, 2000);
    },
    
    // 安全的滚动位置获取方法
    getScrollTop() {
      const element = this.$refs.mainContent;
      if (element && element.scrollTop !== undefined) {
        return element.scrollTop;
      }
      return 0;
    },
    
    // 安全的滚动位置设置方法
    setScrollTop(top) {
      const element = this.$refs.mainContent;
      if (element && element.scrollTop !== undefined) {
        element.scrollTop = top;
      }
    }
  },
  beforeDestroy() {
    // 清理工作
    this.refreshing = false;
    this.loading = false;
  }
};
</script>

<style lang="less" scoped>
.my-movie-page {
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
}

/* 导航栏样式 */
.custom-nav-bar {
  height: 3.5rem;
  background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
  position: relative;
  z-index: 10;
}

.nav-bar-content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
}

.nav-bar-left {
  padding: 0.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:active {
    background: rgba(255, 255, 255, 0.2);
  }
}

.nav-bar-arrow {
  color: white;
  font-size: 1.2rem;
  font-weight: bold;
}

.nav-bar-title {
  color: white;
  font-size: 1.1rem;
  font-weight: 600;
  flex: 1;
  text-align: center;
}

/* 主要内容区域 */
.main-content {
  padding: 1rem;
  background: #f5f5f5;
  min-height: calc(100vh - 3.5rem);
}

/* 用户信息卡片 */
.user-card {
  background: white;
  border: 1.5px solid #e8e8e8;
  border-radius: 12px;
  padding: 1.2rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.user-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.avatar-section {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.avatar-container {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #f0f2ff;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-details {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.username {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.user-tips {
  font-size: 0.85rem;
  color: #666;
  margin: 0;
}

.ticket-count {
  background: linear-gradient(135deg, #3498db, #8e44ad);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
  white-space: nowrap;
}

/* 观看记录区域 */
.watch-section {
  background: white;
  border: 1.5px solid #e8e8e8;
  border-radius: 12px;
  padding: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.section-header {
  padding-bottom: 1rem;
  margin-bottom: 0.5rem;
  border-bottom: 1px solid #f2f2f5;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}

.section-icon {
  width: 20px;
  height: 20px;
}

/* 观看记录列表 */
.watch-history-list {
  padding: 0;
}

.history-item {
  display: flex;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  margin-bottom: 0.8rem;
  padding: 1rem;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  
  &:active {
    border-color: #667eea;
    background: #f8f9ff;
    transform: translateY(1px);
  }
}

.video-thumbnail {
  position: relative;
  width: 120px;
  height: 90px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
}

.thumbnail-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.play-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(102, 126, 234, 0.8);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.play-icon {
  color: #fff;
  font-size: 16px;
  margin-left: 2px;
}

.video-info {
  flex: 1;
  margin-left: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
}

.video-title {
  font-size: 0.95rem;
  font-weight: 500;
  color: #333;
  margin: 0 0 8px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.video-meta {
  margin: 0 0 8px 0;
  font-size: 0.8rem;
  color: #666;
}

.category {
  background: #f0f2ff;
  color: #667eea;
  padding: 2px 6px;
  border-radius: 4px;
  margin-right: 8px;
  font-size: 0.75rem;
}

.duration {
  color: #999;
  font-size: 0.75rem;
}

.watch-time {
  margin: 0;
  font-size: 0.75rem;
  color: #999;
}

.video-actions {
  display: flex;
  align-items: flex-start;
  margin-left: 8px;
}

.video-actions .van-icon {
  color: #ff6b6b;
  font-size: 18px;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.3s;
  
  &:active {
    background: rgba(255, 107, 107, 0.1);
    transform: scale(0.9);
  }
}

/* 空状态 */
.empty-state {
  padding: 2rem 1rem;
  text-align: center;
}

::v-deep .van-empty__image {
  width: 80px;
  height: 80px;
  margin: 0 auto;
}

::v-deep .van-empty__description {
  color: #969799;
  font-size: 0.9rem;
}

/* 响应式调整 */
@media (max-width: 320px) {
  .main-content {
    padding: 0.8rem;
  }
  
  .user-card,
  .watch-section {
    padding: 1rem;
  }
  
  .history-item {
    padding: 0.8rem;
  }
  
  .video-thumbnail {
    width: 100px;
    height: 75px;
  }
  
  .video-title {
    font-size: 0.9rem;
  }
}

/* 动画效果 */
@keyframes fadeInUp {
  from { 
    opacity: 0; 
    transform: translateY(15px); 
  }
  to { 
    opacity: 1; 
    transform: translateY(0); 
  }
}

.history-item {
  animation: fadeInUp 0.4s ease forwards;
}

.history-item:nth-child(odd) {
  animation-delay: 0.1s;
}

.history-item:nth-child(even) {
  animation-delay: 0.2s;
}
</style>